import "../../../src/App.css";
import PetType from "../../components/PetType/PetType";
import AddPetType from "../../components/AddPetType/AddPetType";
import Navbar from "../../components/Navbar/navbar";
import Sidebar from "../../components/Sidebar/Sidebar";
import PetTypeList from "../../components/PetTypeList/PetTypeList";
import React, { useState, useEffect } from "react";
import axios from "axios";
import MasterTopButtons from "../../components/MasterTopButtons/MasterTopButtons";
import MiniDrawer from "../../components/MiniDrawer/MiniDrawer";
import PaginationLink from "../../components/Pagination/Pagination";
import Wrapper from "../../components/UI/Wrapper";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";

function PetTypeMaster() {
  const [petTypeDetailResponse, setPetTypeDetailResponse] = useState(null);
  const [openProfile, setOpenProfile] = useState(false);
  const [openAddProfile, setOpenAddProfile] = useState(false);
  const [filterCityData, setFilterCityData] = useState(false);
  const [petTypeId, setPetTypeId] = useState();
  const title = "Add PetType";
  const heading = "PetType List";
  const baseAPI = process.env.REACT_APP_API_URL;

  function tokenStorage(){
    const storedToken = JSON.parse(localStorage.getItem("token"));
    //console.log(storedToken);

    if (storedToken) {
      axios
        .get(`${baseAPI}adminget/GEPetType?PetType=0`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          //console.log(response.data.data);
          setPetTypeDetailResponse(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }
  useEffect(() => {
    tokenStorage();
  }, []);

  //console.log(petTypeDetailResponse);
  const GetId = (param) => {
    setPetTypeId(param);

  };

  return (
    <>
      <div className="d-flex flex-row app">
        <MiniDrawer />
        <div
          className="container-fluid"
          style={{ padding: "4rem 1rem 1rem 1rem", backgroundColor: "#F4F4F4" }}
        >
          <div
            className="d-flex flex-column w-100"
            style={{ backgroundColor: "#F4F4F4" }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <div>
                <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
                  Pet Type Master| <HomeOutlinedIcon />{" "}
                  <span style={{ fontSize: "20px" }}>&gt; Master</span>
                </h1>
              </div>
              <div style={{ width: "8rem" }}>
                <select className="form-control" name="country">
                  <option value="0">INDIA </option>
                  <option value="1">DUBAI </option>
                </select>
              </div>
            </div>
            <div>
              <Wrapper className="ViewLeadDetails">
                <MasterTopButtons
                  title={title}
                  heading={heading}
                  setOpenAddProfile={setOpenAddProfile}
                  openAddProfile={openAddProfile}
                  setOpenProfile = {setOpenProfile}
                  setFilterCityData = {setFilterCityData}
                  filterCityData = {filterCityData}
                />
                {openAddProfile ? <AddPetType tokenStorage = {tokenStorage} openAddProfile = {openAddProfile} setOpenAddProfile = {setOpenAddProfile}/> : null}
                {openProfile ? <PetType tokenStorage = {tokenStorage} openProfile = {openProfile} setOpenProfile = {setOpenProfile} petTypeId={petTypeId} /> : null}
                <PetTypeList
                  petTypeDetailResponse={petTypeDetailResponse}
                  setOpenProfile={setOpenProfile}
                  openProfile={openProfile}
                  GetId={(param) => GetId(param)}
                  openAddProfile = {openAddProfile} 
                  setOpenAddProfile = {setOpenAddProfile}
                />
                <PaginationLink />
              </Wrapper>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PetTypeMaster;
